import { resolveCreatorGradeCode } from '@repo/services/hooks';
import { getServiceName } from '@repo/utils';

import { useGetMyProfile } from 'services/hooks/user';

/**
 * 별지기(크리에이터 최상위 등급) 여부 (#2182).
 *
 * 판별의 단일 출처는 크리에이터 등급 데이터다 (#2039 · 어드민 전환은 #2045).
 * 리워드 전용 판별 필드를 따로 두면 어드민에서 등급을 바꿨을 때 화면과 어긋난다.
 * 프로필은 이미 대시보드가 부르고 있어 추가 요청이 생기지 않는다.
 */

const STARKEEPER_GRADE_CODE = 'STARKEEPER';

/** MG 대상은 버블챗 크리에이터뿐이다 (기획 확인 9번) */
const MG_SERVICE_NAME = 'bubblechat';

export const useIsStargazer = () => {
  const { data: profile, isFetched } = useGetMyProfile();

  // 등급 필드가 없는 낡은 응답은 별지기가 아니다. isCreator 폴백은 1단계(별가루)까지만 올라가므로
  // 여기서는 볼 필요가 없다.
  //
  // 서비스 조건을 함께 거는 이유: 이 대시보드는 bubblechat-reward 와 tingle-reward 가 공유한다.
  // 등급 코드만 보면 팅글 프로필이 어떤 이유로든 STARKEEPER 를 내려줄 때 팅글에도 MG 섹션이 열린다.
  // "대상은 버블챗만" 을 데이터 가정이 아니라 코드로 지킨다.
  const isStargazer =
    getServiceName() === MG_SERVICE_NAME && resolveCreatorGradeCode(profile) === STARKEEPER_GRADE_CODE;

  return { isStargazer, isFetched };
};
